import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.528 6.125q-.27 0-.534.031L17.2 0h-2.81v1.375h1.748l.401 1.377H9.796l-.348-1.377h.774V0H6.067v1.375H8l.495 1.959L6.331 6.52a4.5 4.5 0 0 0-1.858-.395C2.006 6.125 0 8.085 0 10.497c0 2.41 2.006 4.372 4.472 4.372 2.227 0 4.079-1.6 4.417-3.685h2.455l5.8-6.355.498 1.704c-1.526.697-2.586 2.211-2.586 3.964 0 2.41 2.006 4.372 4.472 4.372S24 12.907 24 10.497s-2.006-4.372-4.472-4.372M4.472 13.493c-1.69 0-3.066-1.345-3.066-2.997 0-1.653 1.376-2.998 3.066-2.998.375 0 .733.067 1.065.187l-2.376 3.498h4.295c-.319 1.322-1.535 2.31-2.984 2.31m1.311-3.685.925-1.36c.36.375.623.842.748 1.36zm3.106 0A4.34 4.34 0 0 0 7.5 7.283l1.452-2.137 1.18 4.664H8.888zM15.9 4.127l-4.509 4.94-1.249-4.94zm3.627 9.367c-1.69 0-3.066-1.345-3.066-2.997 0-1.123.635-2.103 1.572-2.617l.818 2.805 1.352-.377-.818-2.805q.07-.004.142-.004c1.69 0 3.066 1.345 3.066 2.998 0 1.652-1.376 2.997-3.066 2.997"
    }, null, -1)
  ]))]))
}
export default { render: render }